export default __webpack_public_path__ + "static/media/KG.cda44b27.svg";